///
/// EarthBrowser
///
/// Created by Matt Giger on 9/17/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v45 -> v46: Add recentCommands to the userInterface slice (persisted
/// recently-used layers panel commands). Rehydrate replaces the slice
/// wholesale, so existing users need the field seeded to an empty array.
///

export function migrateV45toV46(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const userInterface = s.userInterface as Record<string, unknown> | undefined
	if (!userInterface || userInterface.recentCommands) return state

	return {
		...s,
		userInterface: {
			...userInterface,
			recentCommands: [],
		},
	}
}
